


import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave, FaTimes, FaCheck, FaToggleOn, FaToggleOff } from "react-icons/fa";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import "./FoodBillingsetup.css";
import { getAdminBillingDataAPI, saveAdminBillingDataAPI } from "../../../Servicefile/SettingsAndControlService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Edit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Save: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
        </svg>
    ),
    Close: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Settings: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
    ),
    DineIn: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
        </svg>
    ),
    Takeaway: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Delivery: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="3" width="15" height="13" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18" r="2.5" />
            <circle cx="18.5" cy="18" r="2.5" />
        </svg>
    ),
    DineOut: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
    ),
    GST: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
        </svg>
    ),
    Settlement: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {

        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    card: {
        background: 'white',
        borderRadius: '14px',
        border: '1px solid #edf2f7',
        padding: '18px 22px',
        marginBottom: '14px',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    },
    cardHover: {
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        borderColor: '#e66d33'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '12px',
        width: '100%'
    },
    cardTitle: {
        margin: 0,
        fontSize: '16px',
        fontWeight: '600',
        color: '#1a1a2e',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    cardTitleIcon: {
        width: '32px',
        height: '32px',
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '15px',
        flexShrink: 0
    },
    cardRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    toggleGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        flexWrap: 'wrap',
        padding: '8px 12px',
        background: '#f7fafc',
        borderRadius: '10px',
        border: '1px solid #edf2f7'
    },
    toggleItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        whiteSpace: 'nowrap'
    },
    toggleLabel: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#4a5568'
    },
    toggleSwitch: {
        position: 'relative',
        display: 'inline-block',
        width: '44px',
        height: '24px',
        flexShrink: 0
    },
    toggleInput: {
        opacity: 0,
        width: 0,
        height: 0
    },
    toggleSlider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#cbd5e0',
        transition: '.3s',
        borderRadius: '34px'
    },
    toggleSliderChecked: {
        backgroundColor: '#10b981'
    },
    toggleSliderBefore: {
        position: 'absolute',
        content: '""',
        height: '17px',
        width: '17px',
        left: '4px',
        bottom: '3.5px',
        backgroundColor: 'white',
        transition: '.3s',
        borderRadius: '50%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    },
    toggleSliderBeforeChecked: {
        transform: 'translateX(19px)'
    },
    statusText: {
        fontSize: '12px',
        fontWeight: '600',
        padding: '4px 14px',
        borderRadius: '20px',
        textAlign: 'center',
        minWidth: '65px'
    },
    statusEnabled: {
        color: '#276749',
        background: '#c6f6d5'
    },
    statusDisabled: {
        color: '#9b2c2c',
        background: '#fed7d7'
    },
    button: {
        padding: '6px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '34px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 2px 10px rgba(230, 109, 51, 0.3)'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        boxShadow: '0 2px 10px rgba(16, 185, 129, 0.3)'
    },
    formContainer: {
        marginTop: '16px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    formRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '16px',
        width: '100%'
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },
    label: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#4a5568',
        display: 'block',
        marginBottom: '4px'
    },
    inputWrapper: {
        position: 'relative',
        width: '100%'
    },
    input: {
        width: '100%',
        padding: '10px 14px',
        paddingRight: '35px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '14px',
        outline: 'none',
        transition: 'all 0.3s ease',
        background: 'white',
        height: '44px',
        boxSizing: 'border-box'
    },
    inputSuffix: {
        position: 'absolute',
        right: '14px',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '14px',
        fontWeight: '600',
        color: '#a0aec0'
    },
    cardExpanded: {
        borderColor: '#e66d33',
        boxShadow: '0 4px 24px rgba(230, 109, 51, 0.12)'
    },
    scrollContainer: {
        maxHeight: 'calc(100vh - 190px)',
        overflow: 'auto',
        scrollbarWidth: 'none',
        paddingRight: '4px'
    },
    checkboxInput: {
        width: '18px',
        height: '18px',
        cursor: 'pointer',
        accentColor: '#e66d33'
    }
};

const Foodbillingandsetup = () => {
    const { showLoader, hideLoader } = useLoader();
    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);
    const [hoveredCard, setHoveredCard] = useState(null);

    useEffect(() => {
        fetchBillingData();
    }, []);

    const handlePositiveInputChange = (key, value) => {
        if (value === "") {
            handleValueChange(key, "");
            return;
        }
        if (isNaN(value)) return;
        const numericValue = parseFloat(value);
        if (numericValue < 0) return;
        handleValueChange(key, numericValue);
    };

    const fetchBillingData = async () => {
        try {
            showLoader();
            const result = await getAdminBillingDataAPI();
            setBillingData(result || {});
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            hideLoader();
        }
    };

    const toggleEdit = (key) => {
        setEditMode((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            showLoader();
            const payload = { adminId: 1, ...billingData };
            await saveAdminBillingDataAPI(payload);
            alert("✅ Saved Successfully");
        } catch (error) {
            console.error("Save Error:", error);
            alert(error.response?.data?.message || "Failed to save billing data");
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const allSections = [
        {
            title: "Dine-in Charges",
            icon: <Icons.DineIn />,
            enabledKey: "dineinDynamicPlatformEnabled",
            visibilityKey: "dineinPlatformChargesVisibility",
            thresholdKey: "dineinPlatformThresholdAmount",
            belowKey: "dineinPlatformChargeBelow",
            aboveKey: "dineinPlatformChargeAbove",
            percentageKey: "dineinPlatformChargeIsPercentage",
            editKey: "dineinPlatformEdit",
        },
        {
            title: "Takeaway Charges",
            icon: <Icons.Takeaway />,
            enabledKey: "takeawayDynamicPlatformEnabled",
            visibilityKey: "takeawayplatformChargesVisibility",
            thresholdKey: "takeawayPlatformThresholdAmount",
            belowKey: "takeawayPlatformChargeBelow",
            aboveKey: "takeawayPlatformChargeAbove",
            percentageKey: "takeawayPlatformChargeIsPercentage",
            editKey: "takeawayPlatformEdit",
        },
        {
            title: "Delivery Charges",
            icon: <Icons.Delivery />,
            enabledKey: "deliveryDynamicPlatformEnabled",
            visibilityKey: "deliveryplatformChargesVisibility",
            valueKey: "deliveryCharges",
            radiusKey: "deliveryRadius",
            thresholdKey: "deliveryPlatformThresholdAmount",
            belowKey: "deliveryPlatformChargeBelow",
            aboveKey: "deliveryPlatformChargeAbove",
            percentageKey: "deliveryPlatformChargeIsPercentage",
            editKey: "deliveryPlatformEdit",
            commissionField: {
                title: "Commission Charges",
                valueKey: "commissionCharges",
            },
        },
        {
            title: "Dine Out Charges",
            icon: <Icons.DineOut />,
            enabledKey: "tableDynamicPlatformEnabled",
            visibilityKey: "tableplatformChargesVisibility",
            thresholdKey: "tablePlatformThresholdAmount",
            belowKey: "tablePlatformChargeBelow",
            aboveKey: "tablePlatformChargeAbove",
            percentageKey: "tablePlatformChargeIsPercentage",
            perTableChargesKey: "perTableCharges",
            editKey: "tablePlatformEdit",
        },
        {
            title: "GST Settings",
            icon: <Icons.GST />,
            editKey: "gstEdit",
            gstFields: [
                { title: "Platform Charges GST", valueKey: "platformchargeGst" },
                { title: "Commission Charges GST", valueKey: "commissionGst" },
                { title: "Service Charges GST", valueKey: "serviceChargeGst" },
                { title: "Packaging Charge GST", valueKey: "packagingChargeGst" },
            ],
        },
        {
            title: "Settlement Settings",
            icon: <Icons.Settlement />,
            editKey: "settlementsEdit",
            settlementFields: [
                { title: "TDS", valueKey: "tds", isPercentage: true },
                { title: "Vendor Credit Points", valueKey: "vendorCreditPointsLimit" },
                { title: "Payment Gateway Charges", valueKey: "paymentGatewayCharges", isPercentage: true },
            ],
        },
    ];

    return (
        <div style={styles.container}>
            {/* Header */}
            <div style={styles.header}>
                <div style={styles.title}>
                    <Icons.Settings /> Billing & Setup
                    <span style={styles.titleBadge}>{Object.keys(billingData).length}</span>
                </div>
                <div>
                    <button
                        onClick={fetchBillingData}
                        style={{ ...styles.button, ...styles.buttonPrimary }}
                    >
                        🔄 Refresh
                    </button>
                </div>
            </div>

            {/* Scrollable Content */}
            <div style={styles.scrollContainer}>
                {allSections.map((item, index) => {
                    const isEditing = editMode[item.editKey] || false;
                    const isExpanded = isEditing;

                    return (
                        <div
                            key={index}
                            style={{
                                ...styles.card,
                                ...(isExpanded ? styles.cardExpanded : {}),
                                ...(hoveredCard === index ? styles.cardHover : {})
                            }}
                            onMouseEnter={() => setHoveredCard(index)}
                            onMouseLeave={() => setHoveredCard(null)}
                        >
                            {/* Card Header */}
                            <div style={styles.cardHeader}>
                                <div style={styles.cardTitle}>
                                    <span style={styles.cardTitleIcon}>
                                        {item.icon}
                                    </span>
                                    {item.title}
                                </div>

                                <div style={styles.cardRight}>
                                    {/* Toggle Group - Only show when editing */}
                                    {item.title !== "GST Settings" &&
                                        item.title !== "Settlement Settings" &&
                                        (!item.valueKey || item.title === "Delivery Charges") &&
                                        isEditing && (
                                            <div style={styles.toggleGroup}>
                                                <div style={styles.toggleItem}>
                                                    <span style={styles.toggleLabel}>Dynamic</span>
                                                    <label style={styles.toggleSwitch}>
                                                        <input
                                                            type="checkbox"
                                                            checked={billingData[item.enabledKey] || false}
                                                            onChange={() =>
                                                                handleValueChange(
                                                                    item.enabledKey,
                                                                    !billingData[item.enabledKey]
                                                                )
                                                            }
                                                            style={styles.toggleInput}
                                                        />
                                                        <span style={{
                                                            ...styles.toggleSlider,
                                                            ...(billingData[item.enabledKey] ? styles.toggleSliderChecked : {})
                                                        }}>
                                                            <span style={{
                                                                ...styles.toggleSliderBefore,
                                                                ...(billingData[item.enabledKey] ? styles.toggleSliderBeforeChecked : {})
                                                            }} />
                                                        </span>
                                                    </label>
                                                </div>

                                                <div style={styles.toggleItem}>
                                                    <span style={styles.toggleLabel}>Value</span>
                                                    <input
                                                        type="checkbox"
                                                        checked={!billingData[item.percentageKey]}
                                                        onChange={() =>
                                                            handleValueChange(item.percentageKey, false)
                                                        }
                                                        style={styles.checkboxInput}
                                                    />
                                                </div>

                                                <div style={styles.toggleItem}>
                                                    <span style={styles.toggleLabel}>%</span>
                                                    <input
                                                        type="checkbox"
                                                        checked={billingData[item.percentageKey] || false}
                                                        onChange={() =>
                                                            handleValueChange(item.percentageKey, true)
                                                        }
                                                        style={styles.checkboxInput}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                    {/* Status & Buttons */}
                                    {item.title !== "GST Settings" &&
                                        item.title !== "Settlement Settings" && (
                                            <span style={{
                                                ...styles.statusText,
                                                ...(billingData[item.visibilityKey] ? styles.statusEnabled : styles.statusDisabled)
                                            }}>
                                                {billingData[item.visibilityKey] ? 'Active' : 'Inactive'}
                                            </span>
                                        )}

                                    {!isEditing ? (
                                        <button
                                            onClick={() => toggleEdit(item.editKey)}
                                            style={{ ...styles.button, ...styles.buttonPrimary }}
                                        >
                                            <Icons.Edit /> Edit
                                        </button>
                                    ) : (
                                        <>
                                            <button
                                                onClick={() => {
                                                    handleSave();
                                                    toggleEdit(item.editKey);
                                                }}
                                                style={{ ...styles.button, ...styles.buttonSuccess }}
                                            >
                                                <Icons.Save /> Save
                                            </button>
                                            <button
                                                onClick={() => toggleEdit(item.editKey)}
                                                style={{ ...styles.button, ...styles.buttonSecondary }}
                                            >
                                                <Icons.Close /> Close
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Form Fields - Expanded View */}
                            {isEditing && (
                                <div style={styles.formContainer}>
                                    {/* GST Fields - 4 Columns */}
                                    {item.title === "GST Settings" && (
                                        <div style={styles.formRow}>
                                            {item.gstFields.map((gstItem, gstIndex) => (
                                                <div key={gstIndex} style={styles.formGroup}>
                                                    <label style={styles.label}>{gstItem.title}</label>
                                                    <div style={styles.inputWrapper}>
                                                        <input
                                                            type="number"
                                                            value={billingData[gstItem.valueKey] ?? ""}
                                                            onChange={(e) =>
                                                                handlePositiveInputChange(gstItem.valueKey, e.target.value)
                                                            }
                                                            style={styles.input}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor = '#e66d33';
                                                                e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor = '#e2e8f0';
                                                                e.target.style.boxShadow = 'none';
                                                            }}
                                                            placeholder="0"
                                                        />
                                                        <span style={styles.inputSuffix}>%</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Settlement Fields - 3 Columns */}
                                    {item.title === "Settlement Settings" && (
                                        <div style={styles.formRow}>
                                            {item.settlementFields.map((settlementItem, settlementIndex) => (
                                                <div key={settlementIndex} style={styles.formGroup}>
                                                    <label style={styles.label}>{settlementItem.title}</label>
                                                    <div style={styles.inputWrapper}>
                                                        <input
                                                            type="number"
                                                            value={billingData[settlementItem.valueKey] ?? ""}
                                                            onChange={(e) =>
                                                                handlePositiveInputChange(settlementItem.valueKey, e.target.value)
                                                            }
                                                            style={styles.input}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor = '#e66d33';
                                                                e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor = '#e2e8f0';
                                                                e.target.style.boxShadow = 'none';
                                                            }}
                                                            placeholder="0"
                                                        />
                                                        {settlementItem.isPercentage && (
                                                            <span style={styles.inputSuffix}>%</span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Other Fields - Dynamic Rows */}
                                    {item.title !== "GST Settings" && item.title !== "Settlement Settings" && (
                                        <>
                                            {/* Value Field */}
                                            {item.valueKey && (
                                                <div style={styles.formRow}>
                                                    <div style={styles.formGroup}>
                                                        <label style={styles.label}>
                                                            {item.title === "Delivery Charges" ? "Delivery Charges (per Km)" : item.title}
                                                        </label>
                                                        <div style={styles.inputWrapper}>
                                                            <input
                                                                type="number"
                                                                value={billingData[item.valueKey] ?? ""}
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(item.valueKey, e.target.value)
                                                                }
                                                                style={styles.input}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#e66d33';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e2e8f0';
                                                                    e.target.style.boxShadow = 'none';
                                                                }}
                                                                placeholder="0"
                                                            />
                                                            {(item.title === "Commission Charges") && (
                                                                <span style={styles.inputSuffix}>%</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Delivery Extra Fields */}
                                            {item.title === "Delivery Charges" && (
                                                <div style={styles.formRow}>
                                                    <div style={styles.formGroup}>
                                                        <label style={styles.label}>Delivery Radius (Km)</label>
                                                        <div style={styles.inputWrapper}>
                                                            <input
                                                                type="number"
                                                                value={billingData[item.radiusKey] ?? ""}
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(item.radiusKey, e.target.value)
                                                                }
                                                                style={styles.input}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#e66d33';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e2e8f0';
                                                                    e.target.style.boxShadow = 'none';
                                                                }}
                                                                placeholder="0"
                                                            />
                                                            <span style={styles.inputSuffix}>KM</span>
                                                        </div>
                                                    </div>

                                                    {/* Base Delivery Charges */}
                                                    <div style={styles.formGroup}>
                                                        <label style={styles.label}>Base Delivery Charges</label>
                                                        <div style={styles.inputWrapper}>
                                                            <input
                                                                type="number"
                                                                value={billingData.baseDeliveryCharges ?? ""}
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange("baseDeliveryCharges", e.target.value)
                                                                }
                                                                style={styles.input}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = "#e66d33";
                                                                    e.target.style.boxShadow = "0 0 0 3px rgba(230, 109, 51, 0.1)";
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = "#e2e8f0";
                                                                    e.target.style.boxShadow = "none";
                                                                }}
                                                                placeholder="0"
                                                            />
                                                            <span style={styles.inputSuffix}>₹</span>
                                                        </div>
                                                    </div>

                                                    <div style={styles.formGroup}>
                                                        <label style={styles.label}>{item.commissionField.title}</label>
                                                        <div style={styles.inputWrapper}>
                                                            <input
                                                                type="number"
                                                                value={billingData[item.commissionField.valueKey] ?? ""}
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(item.commissionField.valueKey, e.target.value)
                                                                }
                                                                style={styles.input}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#e66d33';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e2e8f0';
                                                                    e.target.style.boxShadow = 'none';
                                                                }}
                                                                placeholder="0"
                                                            />
                                                            <span style={styles.inputSuffix}>%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Platform Fields */}
                                            {((!item.valueKey || item.title === "Delivery Charges") && (
                                                <div style={styles.formRow}>
                                                    {billingData[item.enabledKey] && (
                                                        <div style={styles.formGroup}>
                                                            <label style={styles.label}>Threshold Amount</label>
                                                            <div style={styles.inputWrapper}>
                                                                <input
                                                                    type="number"
                                                                    value={billingData[item.thresholdKey] ?? ""}
                                                                    onChange={(e) =>
                                                                        handlePositiveInputChange(item.thresholdKey, e.target.value)
                                                                    }
                                                                    style={styles.input}
                                                                    onFocus={(e) => {
                                                                        e.target.style.borderColor = '#e66d33';
                                                                        e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        e.target.style.borderColor = '#e2e8f0';
                                                                        e.target.style.boxShadow = 'none';
                                                                    }}
                                                                    placeholder="0"
                                                                />
                                                                <span style={styles.inputSuffix}>₹</span>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div style={styles.formGroup}>
                                                        <label style={styles.label}>Platform Charge Below</label>
                                                        <div style={styles.inputWrapper}>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                step="0.01"
                                                                value={billingData[item.belowKey] ?? ""}
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(item.belowKey, e.target.value)
                                                                }
                                                                style={styles.input}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#e66d33';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e2e8f0';
                                                                    e.target.style.boxShadow = 'none';
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "-" || e.key === "+" || e.key === "e") {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                placeholder="0"
                                                            />
                                                            <span style={styles.inputSuffix}>
                                                                {billingData[item.percentageKey] ? '%' : '₹'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {billingData[item.enabledKey] && (
                                                        <div style={styles.formGroup}>
                                                            <label style={styles.label}>Platform Charge Above</label>
                                                            <div style={styles.inputWrapper}>
                                                                <input
                                                                    type="number"
                                                                    value={billingData[item.aboveKey] ?? ""}
                                                                    onChange={(e) =>
                                                                        handlePositiveInputChange(item.aboveKey, e.target.value)
                                                                    }
                                                                    style={styles.input}
                                                                    onFocus={(e) => {
                                                                        e.target.style.borderColor = '#e66d33';
                                                                        e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        e.target.style.borderColor = '#e2e8f0';
                                                                        e.target.style.boxShadow = 'none';
                                                                    }}
                                                                    placeholder="0"
                                                                />
                                                                <span style={styles.inputSuffix}>
                                                                    {billingData[item.percentageKey] ? '%' : '₹'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}

                                            {/* Per Table Charges */}
                                            {item.title === "Dine Out Charges" && (
                                                <div style={styles.formRow}>
                                                    <div style={styles.formGroup}>
                                                        <label style={styles.label}>Per Table Charges</label>
                                                        <div style={styles.inputWrapper}>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                step="0.01"
                                                                value={billingData[item.perTableChargesKey] ?? ""}
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(item.perTableChargesKey, e.target.value)
                                                                }
                                                                style={styles.input}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#e66d33';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e2e8f0';
                                                                    e.target.style.boxShadow = 'none';
                                                                }}
                                                                placeholder="0"
                                                            />
                                                            <span style={styles.inputSuffix}>₹</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <style>{`
                @media (max-width: 992px) {
                    .form-row {
                        grid-template-columns: repeat(2, 1fr) !important;
                    }
                }

                @media (max-width: 768px) {
                    .card-header {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    .card-right {
                        flex-wrap: wrap !important;
                        justify-content: flex-start !important;
                    }
                    .toggle-group {
                        flex-wrap: wrap !important;
                        width: 100% !important;
                        justify-content: center !important;
                    }
                    .form-row {
                        grid-template-columns: 1fr !important;
                    }
                    .container {
                        padding: 12px 10px !important;
                    }
                    .card {
                        padding: 14px 16px !important;
                    }
                    .card-title {
                        font-size: 14px !important;
                    }
                    .button {
                        font-size: 12px !important;
                        padding: 4px 12px !important;
                        height: 30px !important;
                    }
                    .toggle-switch {
                        width: 36px !important;
                        height: 20px !important;
                    }
                    .toggle-slider-before {
                        height: 14px !important;
                        width: 14px !important;
                        left: 3px !important;
                        bottom: 3px !important;
                    }
                    .toggle-slider-before-checked {
                        transform: translateX(16px) !important;
                    }
                    .input {
                        height: 38px !important;
                        font-size: 13px !important;
                        padding: 6px 10px !important;
                    }
                    .status-text {
                        font-size: 11px !important;
                        padding: 2px 10px !important;
                        min-width: 55px !important;
                    }
                    .input-suffix {
                        font-size: 12px !important;
                        right: 10px !important;
                    }
                    .toggle-label {
                        font-size: 11px !important;
                    }
                }

                @media (max-width: 480px) {
                    .card-header {
                        gap: 8px !important;
                    }
                    .card-right {
                        gap: 8px !important;
                    }
                    .toggle-group {
                        gap: 10px !important;
                        padding: 6px 10px !important;
                    }
                    .toggle-item {
                        gap: 4px !important;
                    }
                    .button {
                        font-size: 11px !important;
                        padding: 3px 10px !important;
                        height: 26px !important;
                        gap: 4px !important;
                    }
                    .status-text {
                        font-size: 10px !important;
                        padding: 2px 8px !important;
                        min-width: 45px !important;
                    }
                    .input {
                        height: 34px !important;
                        font-size: 12px !important;
                        padding: 4px 8px !important;
                    }
                    .input-suffix {
                        font-size: 11px !important;
                        right: 8px !important;
                    }
                    .label {
                        font-size: 11px !important;
                    }
                    .scroll-container {
                        max-height: calc(90vh - 160px) !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }
            `}</style>
        </div>
    );
};

export default Foodbillingandsetup;